// extracted by css-extract-rspack-plugin
export default {"quote":"src-Quote-quote-17a3a30d","icon":"src-Quote-icon-e16a7012"};